import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import simplebar from "simplebar-vue";
import BaseMixer from "@/router/views/BaseMixer";
import { PACycleSaveModel } from "@/store/models/cycle/paCycleSaveDTO";
let LetsFinishComponent = /** @class */ (() => {
    var _a;
    let LetsFinishComponent = class LetsFinishComponent extends Mixins(BaseMixer) {
        created() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof PACycleSaveModel !== "undefined" && PACycleSaveModel) === "function" ? _a : Object)
    ], LetsFinishComponent.prototype, "paCycleSave", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], LetsFinishComponent.prototype, "EmployeesWorFlow", void 0);
    LetsFinishComponent = __decorate([
        Component({
            name: "LetsFinishComponent",
            components: {
                simplebar,
            },
        })
    ], LetsFinishComponent);
    return LetsFinishComponent;
})();
export default LetsFinishComponent;
